var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Button as ButtonBaseM, CircularProgress, IconButton, makeStyles, styled } from '@material-ui/core';
import { useLinked } from '@type-r/react';
import * as React from 'react';
import { useQaId } from './qa-ids';
import { colors } from '../common';
var ButtonBase = function (_a) {
    var qaId = _a["qa-id"], children = _a.children, props = __rest(_a, ['qa-id', "children"]);
    var id = useQaId(qaId || children);
    return React.createElement(ButtonBaseM, __assign({}, props, { "data-qa-id": id }),
        " ",
        children,
        " ");
};
export var XLargeButton = function (_a) {
    var children = _a.children, icon = _a.icon, qaId = _a["qa-id"], ticked = _a.ticked, rest = __rest(_a, ["children", "icon", 'qa-id', "ticked"]);
    var classes = useXLargeButtonStyle({ ticked: ticked });
    var id = useQaId(qaId || children);
    return (React.createElement(IconButton, __assign({ className: classes.root + ' ' + classes.label }, rest, { "data-qa-id": id }),
        React.createElement("img", { className: classes.image, src: icon, alt: id }),
        React.createElement("div", { className: classes.content }, children),
        ticked && React.createElement("img", { className: classes.tick, src: "/assets/images/tick.png", alt: "Tick" })));
};
var useXLargeButtonStyle = makeStyles({
    root: {
        width: '100%',
        height: '110px',
        background: function (props) { return props.ticked ? '#E9F9F3' : '#FFFFFF'; },
        border: function (props) { return props.ticked ? '1px solid #58C091' : '1px solid #E7F2F9'; },
        borderRadius: '4px',
        boxSizing: 'border-box'
    },
    image: {
        width: '83.81px',
        height: '80px',
        background: function (props) { return props.ticked ? '#58C091' : '#F4FAFD'; },
        borderRadius: '4px'
    },
    label: {
        justifyContent: 'normal'
    },
    tick: {
        marginLeft: 'auto',
        paddingRight: '20px'
    },
    content: {
        width: '70%',
        minWidth: '200px',
        wordBreak: 'break-word',
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '20px',
        lineHeight: '24px',
        display: 'block',
        alignItems: 'center',
        textAlign: 'left',
        color: function (props) { return props.ticked ? '#58C091' : '#3B84CD'; },
        flex: 'none',
        order: 0,
        flexGrow: 0,
        paddingBottom: '10px',
        paddingLeft: '10px',
        '& span': {
            fontWeight: '600',
            fontSize: '13px',
            lineHeight: '16px',
            color: '#1F2530'
        },
    }
});
export var AttachButton = function (props) {
    var id = useQaId('attach-button');
    return (React.createElement(IconButton, __assign({ size: "small" }, props, { "data-qa-id": id, "aria-label": "Attach" }),
        React.createElement("img", { src: "/assets/images/circle-attach.png", alt: "Attach" })));
};
export var EditButton = function (props) {
    var id = useQaId('edit-button');
    return (React.createElement(IconButton, __assign({ "aria-label": "Edit", size: "small" }, props, { "data-qa-id": id }),
        React.createElement("img", { src: "/assets/images/circle-edit.png", alt: "Edit" })));
};
function IoOnClick(Component) {
    var C = Component;
    return function IoOnClickWrapper(_a) {
        var children = _a.children, onClick = _a.onClick, props = __rest(_a, ["children", "onClick"]);
        var pendingIO = useLinked(false);
        function ioWrapper(e) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, , 2, 3]);
                            pendingIO.true();
                            return [4 /*yield*/, onClick(e)];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            pendingIO.false();
                            return [7 /*endfinally*/];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        return (React.createElement(C, __assign({ onClick: ioWrapper }, props), pendingIO.value ? React.createElement(CircularProgress, { size: 20 }) : children));
    };
}
var buttonStyles = {
    boxSizing: 'content-box',
    marginLeft: 8,
    marginRight: 8,
    borderRadius: 18,
    paddingLeft: 16,
    paddingRight: 16,
    fontFamily: 'Montserrat',
    fontSize: 14,
    boxShadow: 'none',
    textTransform: 'none',
};
var defaultPrimaryColor = function (props) { return colors[props.color] || '#4bb885'; };
export var PrimaryButton = styled(ButtonBase)(__assign({}, buttonStyles, { backgroundColor: defaultPrimaryColor, color: function (props) { return props.color === 'yellow' ? 'black' : 'white'; }, borderWidth: 2, borderColor: defaultPrimaryColor, paddingTop: 1, paddingBottom: 1, '&:hover': {
        color: 'white',
        boxShadow: '2px 0 4px 0 rgba(0,0,0,0.1)',
        backgroundColor: defaultPrimaryColor,
    }, '&:active': {
        backgroundColor: defaultPrimaryColor,
    }, '&:focus': {
        border: '2px solid #0AC3F3',
        boxShadow: '0 0 2px 0 #0AC3F3, 2px 0 4px 0 rgba(0,0,0,0.1)',
        borderWidth: 0,
        outline: 'none',
    }, '&:disabled': {
        backgroundColor: 'rgba(102,138,165,0.25)',
        opacity: 0.75,
        color: '#FFF',
        fontWeight: 500,
    } }));
export var IoIconButton = IoOnClick(IconButton);
/**
 * Currently there are two types of buttons. Regular `Button` and the colored one for the primary action.
 */
export var Button = styled(ButtonBase)(__assign({}, buttonStyles, { paddingTop: 0, paddingBottom: 0, backgroundColor: '#FFF', border: '1px solid #668AA5', color: '#668AA5', fontWeight: 500, '&:focus': {
        border: '1px solid #0098DB',
        boxShadow: '0 0 2px 0 #0AC3F3, 2px 0 4px 0 rgba(0,0,0,0.1)',
        outline: 'none',
        color: '#0098DB',
        fontWeight: 700,
    }, '&:hover': {
        border: '1px solid #0098DB',
        color: '#0098DB',
        backgroundColor: 'white',
        fontWeight: 600,
        boxShadow: '2px 0 4px 0 rgba(0,0,0,0.1)'
    }, '&:active': {
        color: '#668AA5',
        fontWeight: 500,
        border: '1px solid #668AA5',
        backgroundColor: 'white' //'#F4FAFD'
    } }));
export var IoButton = IoOnClick(Button);
//# sourceMappingURL=buttons.js.map